import { IAPIProxy, getAPIProxy } from '@inwink/apibase';
import { eventEntityViewDataSource } from '../../admin/api/evententityview';
import { userPreferences } from '@@api/base/userPreferences';
import { IDataSourceV3Options, IDataSourceV3, getEntityDataSource } from '@@api/base/datasource';
import { fileInputManager } from '@@api/base/fileinputmanager';
import getCookieAPIProxy from '@@api/apiproxy';

let _eventAPIProxy: IAPIProxy = null;

export const getEventAPIProxy = () => {
    if (!_eventAPIProxy) {
        _eventAPIProxy = inwink.config.clientConfig.authMode === 'cookies'
            ? getCookieAPIProxy(inwink.config.eventApiUrl)
            : getAPIProxy(inwink.config.eventApiUrl);
    }

    return _eventAPIProxy;
};

export function getEventEntityDataSource<T>(
    eventId: string,
    entityRoute: string,
    entityName: string,
    options?: IDataSourceV3Options
): IDataSourceV3<T> {
    const proxy = getEventAPIProxy();
    const userPreferencesDatasource = eventEntityViewDataSource(eventId);
    const userpreferencesProvider = userPreferences(userPreferencesDatasource, entityName, options);
    return getEntityDataSource<T>(proxy, eventId + "/", entityRoute, entityName, userpreferencesProvider, options);
}

export function eventFileInputManager(eventid: string, fileUrlBuilder: (entity: string) => string = null) {
    const proxy = getEventAPIProxy();
    return fileInputManager(eventid, proxy, fileUrlBuilder);
}